import get from "lodash/get";

const initialState = {};

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = initialState, action) => {
  const payload = get(action, "payload", []);
  switch (action.type) {
    case "ADD_ACCOUNT":
      return {
        ...state,
        underwriter_client_list: [...state.underwriter_client_list, action.payload.data],
      };
    case "EDIT_ACCOUNT":
      return {
        ...state,
        underwriter_client_list: state.underwriter_client_list.map((account) => {
          const accountIdFromState = account.AccountId;
          const accountIdFromPayload = action.payload.data.accountId || action.payload.data.AccountId;
          
          if (!accountIdFromState || !accountIdFromPayload) {
            return account;
          }
          
          return accountIdFromState.toString() === accountIdFromPayload.toString()
            ? {
                ...account,
                ...action.payload.data,
              }
            : account;
        }),
      };
    case "ADD_SUB_ACCOUNT":
      return {
        ...state,
        underwriter_client_list: state.underwriter_client_list.map((account) =>
          account.AccountId.toString() ===
          action.payload.data.AccountId.toString()
            ? {
                ...account,
                SubsidiaryAccountInfo: [
                  ...account.SubsidiaryAccountInfo,
                  {
                    ...action.payload.data,
                  },
                ],
              }
            : account,
        ),
      };
    case "EDIT_SUB_ACCOUNT":
      return {
        ...state,
        underwriter_client_list: state.underwriter_client_list.map((account) =>
          account.AccountId == action.payload.data.AccountId
            ? {
                ...account,
                SubsidiaryAccountInfo: account.SubsidiaryAccountInfo.map(
                  (sub) =>
                    sub.SubsidiaryID == action.payload.data.SubsidiaryID
                      ? { ...sub, ...action.payload.data }
                      : sub,
                ),
              }
            : account,
        ),
      };
    case "GET_UNDERWRITER_CLIENT_INFO":
      return {
        ...state,
        underwriter_client_list: payload,
      };
    case "GET_INSTITUTION_INVITED_ESUBS":
      return {
        ...state,
        institution_invited_esubs_list: payload,
      };
    case "GET_UNDERWRITER_LIST_FOR_AGENT":
        return {
          ...state,
          underwriter_list_for_agent: payload,
        };
    case "GET_UNDERWRITER_IDP_ACTIVE_DOCUMENTS":
      return {
        ...state,
        underwriter_idp_active_documents_list: payload,
      };
    case "GET_UNDERWRITER_IDP_ARCHIVED_DOCUMENTS":
      return {
        ...state,
        underwriter_idp_archived_documents_list: payload,
      };
    case "GET_PD_SCORE":
      return {
        ...state,
        underwriter_pd_score_list: payload,
      };
    case "GET_CLIENT_PROJECTS_INFO":
      return {
        ...state,
        client_projects_list: payload,
      };
    case "GET_CLIENT_PROJECTS_INFO_WIP":
      return {
        ...state,
        client_projects_list_wip: payload,
      };
    case "GET_CLIENT_BONDS_INFO":
      return {
        ...state,
        client_bonds_list: payload,
      };
    case "GET_STATUS_REPORT_CHECK":
      return {
        ...state,
        client_status_report_check: payload,
      };
    case "POST_STATUS_REPORT_TRANSACTION":
      return {
        ...state,
        status_report_transaction_list: payload,
      };
    case "VIEW_LATEST_STATUS_REPORT":
      return {
        ...state,
        latest_status_report_details: payload,
      };
    case "POST_FINANCIAL_DATA_ANALYSIS":
      return {
        ...state,
        financial_data_analysis_list: payload,
      };
    default:
      return state;
  }
};
